import { Entity } from 'src/app/core/data/schema/entity';

export class PricingTier extends Entity {

    static className = 'PricingTier';
    static idField = 'pricingTierId';
    static controller = 'pricingtier';

    pricingTierId: number;
    raffleId: number;
    tierName: string;
    ticketPrefix: string;
    quantity: number;
    price: number;
    ticketQuantity: number;
    startNumber: number;
    lastModified: string;
    lastModifiedBy: number;
    isSoldOut: boolean;
    available: number;

    for = 'for';


    public constructor(init?: Partial<PricingTier>) {
        super(PricingTier.className, PricingTier.idField, PricingTier.controller);
        Object.assign(this, init);
    }

    get totalTiers() {
        return this.price * this.quantity;
    }

    get totalTickets() {
        return this.ticketQuantity * this.quantity;
    }

    set totalTickets(val) { }
    set totalTiers(val) { }



}
